import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import { useCommonHooks } from "../../hooks";

import * as React from "react";
import { useQuery } from "react-query";
import { ReferentialItemDto } from "../../api";
import { ETLCodes } from "../../locales";
import { nameof } from "../../utils";

export interface IPostalCodeSelectProps extends IFGSelectInputProps<any> {}

export const PostalCodeSelect: React.FunctionComponent<
  IPostalCodeSelectProps
> = ({ name, label, ...fgSelectInputProps }) => {
  const { t, apis } = useCommonHooks();
  const { data, isFetching } = useQuery(
    "ref-postal-codes",
    async () => {
      return apis.referential.postalCodes();
    },
    { cacheTime: 600 }
  );
  return (
    <FGSelectInput
      label={label || t(ETLCodes.ZipCode)}
      name={name}
      items={data}
      loading={isFetching}
      displayField={nameof<ReferentialItemDto>("displayValue")}
      valueField={nameof<ReferentialItemDto>("idValue")}
      isFilterable={true}
      {...fgSelectInputProps}
    />
  );
};
